import React, { FunctionComponent, useContext } from "react";
import { Theme, makeStyles, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { UserDataContext } from "./context/user-data-context";
import { UserDataAccountInfo } from "./components/user-data-account-info";
import { UserDataDigitalTwinInfo } from "./components/user-data-digital-twin-info";
import { PrimaryButton } from "../../../../components/buttons/primary-button";
import { HeadingText } from "../../../../components/text/heading-text";
import { SubheadingText } from "../../../../components/text/subheading-text";

const useStyles = makeStyles((theme: Theme) => ({
  subheading: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(2),
  },
  saveButtonContainer: {
    marginTop: theme.spacing(5),
    paddingRight: theme.spacing(4),
  },
  saveButton: {
    width: "100%",
  },
}));

interface IUserInformationProps {
  onChangePassword: () => void;
}

export const UserInformation: FunctionComponent<IUserInformationProps> = (props) => {
  const { onChangePassword } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { updateUserInformation, updateUserInformationLoading, allInputsValid, hasChanges } = useContext(
    UserDataContext,
  );
  return (
    <Grid container>
      <Grid item xs={12}>
        <HeadingText>{t("user_data.header")}</HeadingText>
      </Grid>
      <Grid item xs={12} className={classes.subheading}>
        <SubheadingText>{t("user_data.info.account_info.header")}</SubheadingText>
      </Grid>

      <Grid item xs={12}>
        <UserDataAccountInfo onChangePassword={onChangePassword} />
      </Grid>

      <Grid item xs={12} className={classes.subheading}>
        <SubheadingText>{t("user_data.info.digital_twin_info.header")}</SubheadingText>
      </Grid>

      <Grid item xs={12}>
        <UserDataDigitalTwinInfo />
      </Grid>
      <Grid item xs={6} className={classes.saveButtonContainer}>
        <PrimaryButton
          onClick={updateUserInformation}
          loading={updateUserInformationLoading}
          disabled={!allInputsValid || !hasChanges}
          className={classes.saveButton}
        >
          {t("user_data.info.save_button")}
        </PrimaryButton>
      </Grid>
    </Grid>
  );
};
